import { Component, OnInit, OnDestroy, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MainBodyService } from '../services/main-body.service';
import { themeData } from 'src/interface/themesetting';
import { faqData, bookData } from 'src/interface/faq';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { EnvService } from '../services/env.service';
import { JournalService } from '../journal/journal.service';
// import { BookService } from '../book/book.service';
import { bookList, responseData, journalData, Book, JournalType } from 'src/interface/book'
import { faqResponse } from 'src/interface/faq';
import { UniversalStorageService } from '../services/universal-storage.service';
import { Router } from '@angular/router';
import { Subject, Subscription, debounceTime, filter, switchMap } from 'rxjs';
import { listAllarticle, listArticle } from 'src/interface/article';
import { GetArticlesService } from '../services/get-articles.service';
import { PublisherService } from '../services/publisher.service';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

    themeSettingsData: themeData;
    faqData: faqData[];
    journalSubscription: Subscription;
    book: Book[];
    ipAddress: string;
    myValue: string;
    whishlist: string | null;
    bookmark: boolean[];
    token: boolean;
    cover_image_url: string;
    bookData: bookData[];
    currentBookRating: number[];
    journalData: journalData[];
    journalConferenceData: journalData[];
    journalRetiredData: journalData[];
    journalSub: Subscription;
    imageUrl = '';
    defaultJournalCoverImage = '';
    defaultPublisherLogo = '';
    default_cover_image = '';
    default_banner_image = '';
    defaultJournalLogo = '';
    subscriptions: Subscription[] = [];
    searchLoader: boolean;
    valueForSearch = '';
    show_search_list: boolean;
    searchedArticles: listArticle[];
    queryParams: { length: number; start: number; search_key: string; search_filters: string; search_keywords: string; sort_by: string; };
    private searchSubject = new Subject();
    dataToBeDisplay = 3;
    startArticle = 0;
    recentArticles: listArticle[] = [];
    search_filters: string[] = [];
    journalid = 'All';
    selectDiv = true;
    searchSub: Subscription;
    tempSearchArticles: listArticle[] = [];
    subject_area_filter = false;
    journalID: string;
    publisher_id: string;

    constructor(private mainBodyService: MainBodyService,
        private EnvService: EnvService,
        private service: JournalService,
        // private book_service: BookService,
        private storageService: UniversalStorageService,
        private router: Router,
        private articleService: GetArticlesService,
        private publisherService: PublisherService,@Inject(PLATFORM_ID) private platformId: any) {

        this.themeSettingsData = {
            journal_id: '',
            journal_logo: '',
            logo_alt_text: '',
            journal_banner: '',
            journal_display_name: '',
            banner_type: 'fullwidth',
            banner_heading: '',
            banner_content: '',
            banner_secondary_content: '',
            button_label: '',
            button_link: '',
            contact_us: {
                address_line_1: '',
                address_line_2: '',
                address_line_3: '',
                phone_number: 0,
                email: '',
            },
            journal_about: '',
            social_media_links: [
                {
                    label: '',
                    key: '',
                    icon: ['fas', 'facebook'],
                    value: '',
                },
            ],
            theme_colors: {
                button_color: '',
                button_text_color: '',
                primary_color: '',
                primary_footer_background_color: '',
                primary_footer_text_color: '',
                primary_header_background_color: '',
                primary_header_text_color: '',
                secondary_color: '',
                secondary_footer_background_color: '',
                secondary_footer_text_color: '',
                secondary_header_background_color: '',
                secondary_header_text_color: '',
                text_primary_color: '',
                text_secondary_color: '',
            },
            banner_transparent_image: '',
            fullwidthcheck: '',
            transimagecheck: '',
            banner_fullwidth_image: '',
            banner_full_alt_text: '',
            banner_trans_alt_text: '',
            about: '',
            journal_title: '',
        };
    }


    ngOnInit(): void {


        // Call the 'urlchange' method with 'false' argument in 'mainBodyService'
        this.mainBodyService.urlchange(false);
        this.publisherService.fetchPublisherId().subscribe(response => {
            this.publisher_id = response[0].publisher_id;
            // Retrieve theme settings data from the server for 'publisher'
            const getallthemesubs = this.mainBodyService
                .getAllThemeSettings(this.publisher_id)
                .subscribe((result) => {
                    if (result.status == 200) {
                        // If the response status is 200 (OK), store the theme settings data
                        this.themeSettingsData = result.data;
                        this.journalID = result.data.journal_id;
                    }
                    // Apply the theme colors dynamically  using CSS variables
                    if (isPlatformBrowser(this.platformId)) {
                    const color = this.themeSettingsData.theme_colors;
                    const banner_url = this.EnvService.imageUrl + "themes/" + this.themeSettingsData.journal_banner;
                    this.themeSettingsData.journal_banner = banner_url;
                    Object.entries(color).map(([key, value]) => {
                        const element = '--' + key;
                        const val = value;
                        document.documentElement.style.setProperty(element, val);
                    });
                }
                });
            this.subscriptions.push(getallthemesubs);
            // Set default image paths for journal, publisher, and book covers
            this.defaultJournalCoverImage = this.EnvService.defaultImagePath + this.EnvService.default_journalCoverImage;
            this.defaultJournalLogo = this.EnvService.defaultImagePath + this.EnvService.default_journalLogo;
            this.defaultPublisherLogo = this.EnvService.defaultImagePath + this.EnvService.default_publisherLogo;
            this.default_banner_image = this.EnvService.defaultImagePath + this.EnvService.default_banner_image;
            this.imageUrl = this.EnvService.imageUrl + 'themes/';
            this.cover_image_url = this.EnvService.coverImageUrl;
            this.default_cover_image = this.EnvService.defaultImagePath + this.EnvService.default_book_cover_image;
            this.mainBodyService.urlchange(false);
            // Fetch frequently asked questions (FAQ) data from the server
            const getallsubs = this.mainBodyService.getAllFaq().subscribe((result: faqResponse) => {

                if (result.status == 200) {
                    this.faqData = result.data;
                }

            });
            this.subscriptions.push(getallsubs);
            const journalType: JournalType = { jnl_type: "JNL" };
            const journalCurrentConference: JournalType = { jnl_type: "CPC" }
            const journalRetiredConference: JournalType = { jnl_type: "CPR" };
            // Get journal data from the server
            this.journalSubscription = this.service.getJournals(journalType).subscribe();
            // Retrieve the token value from the local storage and check its existence

            // Call the 'getBookDetails' method to fetch book details
            // this.getBookDetails();
            // Fetch journal data again from the server

            this.journalSub = this.service.getJournals(journalType).subscribe((result: responseData) => {
                // Now, result.data is an array of journalData, so you can assign it directly

                this.journalData = result.data;

            });
            this.journalSub = this.service.getJournals(journalCurrentConference).subscribe((result: responseData) => {
                // Now, result.data is an array of journalData, so you can assign it directly

                this.journalConferenceData = result.data;
            });
            this.journalSub = this.service.getJournals(journalRetiredConference).subscribe((result: responseData) => {
                // Now, result.data is an array of journalData, so you can assign it directly

                this.journalRetiredData = result.data;
            });

            this.searchSub = this.searchSubject.pipe(
                filter((text) => String(text).length > 2),
                debounceTime(500),
                switchMap(() =>
                    this.articleService.searchArticle(this.queryParams, this.journalid)
                )
            ).subscribe(result => {
                this.searchLoader = false;
                this.show_search_list = true;
                if (this.valueForSearch.length > 2) {
                    this.searchedArticles = result.data;
                    this.tempSearchArticles = this.searchedArticles;
                }
            })
        });
    }
    // Function to fetch book details 
    // getBookDetails() {
    //     // Create a search object 'listData' with initial parameters
    //     const listData: bookList = {
    //         search_key: '',
    //         length: '10',
    //         start: '0',
    //         filter: 'new_release'

    //     }
    //     // Call the 'getBookDetails' method of 'book_service' with 'listData' as the parameters
    //     const subscription = this.book_service.getBookDetails(listData).subscribe((data) => {
    //         // When the data is received from the server, execute this callback function
    //         // Extract the first 6 books from the received 'data' array
    //         const newArray = data.data.slice(0, 6);
    //         // Assign the extracted 6 books to the component's 'book' property
    //         this.book = newArray;
    //     });
    //     this.subscriptions.push(subscription);
    // }
    // Function to toggle the bookmark status of a book
    setBookmarkStatus(index: number, status: boolean | string, id: string) {

        // Toggle the bookmark status of the book at the given index
        this.bookmark[index] = !this.bookmark[index];

        // If the token does not exist (user is not logged in), perform the following actions:
        // Create an object 'obj' with details of the book to be added to the bookmark (wishlist)
        const obj = {
            "ip": this.ipAddress,
            "whishlist": "true",
            "book_id": id
        }
        // Set the 'obj' object in the local storage with the key 'bookmark'

        this.storageService.setItem("bookmark", obj);
        // Retrieve the 'bookmark' object from the local storage and store it in 'whishlist'
        this.whishlist = this.storageService.getItem("bookmark");

    }
    // Determines the appropriate star icon based on the rating and star number
    getStarIcon(rating: number, star: number): IconProp {
        // Calculate the number of full stars
        const fullStars = Math.floor(rating);
        // Check if there is a half star
        const hasHalfStar = rating - fullStars >= 0.5;
        // Determine the appropriate star icon based on the star number
        if (star <= fullStars) {
            // Return a full star icon
            return { prefix: 'fas', iconName: 'star' };
        } else if (hasHalfStar && star === fullStars + 1) {
            // Return a half star icon
            return { prefix: 'fas', iconName: 'star-half-alt' };
        } else {
            // Return an empty star icon
            return { prefix: 'far', iconName: 'star' };
        }
    }
    // Navigates to the book page
    showBookHome() {
        this.router.navigate(['/books']);
    }
    // Navigates to the journal page
    showJournalHome() {
        this.router.navigate(['/journals']);
    }
    // Function to get the URL for the home image based on the provided theme settings
    getHomeImage(themeSettingsData: themeData) {
        // Initialize the 'image' variable with the default value 'none'
        let image = 'none';

        // Check if the banner type is 'Fullwidth'
        if (themeSettingsData.banner_type == 'Fullwidth') {
            // If the banner type is 'Fullwidth', set 'image' to the URL of the full-width banner image
            image = this.imageUrl + themeSettingsData.banner_fullwidth_image;
        }

        // Check if all banner-related properties are null (no banner settings provided)
        if (
            themeSettingsData.banner_transparent_image == null &&
            themeSettingsData.banner_fullwidth_image == null &&
            themeSettingsData.banner_type == null
        ) {
            // Check if the journal ID is 'publisher'
            if (themeSettingsData.journal_id == this.publisher_id) {
                // If the journal ID is 'publisher', set 'image' to the default banner image
                image = this.default_banner_image;
            } else {
                // If the journal ID is not 'publisher', set 'image' to the default journal cover image
                image = this.defaultJournalCoverImage;
            }
        }

        // Return the determined 'image' URL
        return image;
    }
    // Returns a string of author names concatenated with given names and surnames
    getAuthorNames(authors): string {
        return authors.map(a => a.givenNames + ' ' + a.surname).join(', ');
    }
    // Navigates to the book listing page
    showBook() {
        this.router.navigate(['/book-listing']);
    }
    // Navigates to the book chapter page
    showBookChapterListing(data) {
        const id = data;
        this.router.navigate(['/book', id]);
    }

    searchEmitFunction(searchData: string) {
        this.searchLoader = true;
        this.valueForSearch = searchData;
        this.show_search_list = true;
        this.searchedArticles = [];
        this.queryParams = {
            length: this.dataToBeDisplay,
            start: this.startArticle,
            search_key: this.valueForSearch,
            search_filters: '',
            search_keywords: '',
            sort_by: ''
        }
        this.searchSubject.next(this.valueForSearch);
    }
    clearSearch(isClick: boolean) {
        if (isClick) {
            this.searchedArticles = [];
        }
        this.show_search_list = false;
        this.valueForSearch = '';
        const queryParams: listAllarticle = {
            length: this.dataToBeDisplay,
            start: 0,
            search_key: '',
            search_filters: '',
            search_keywords: '',
            sort_by: '',
            volume_id: '',
            issue_id: '',
            special_issue:false,
            thematic_id: ''
            // favourites_data:[],
            // journal_id:''
        }
        this.articleService.getArticles(queryParams, '').subscribe(result => {
            this.recentArticles = result.data;
        })
    }

    showSearchedArticle(isClicked: boolean) {
        if (isClicked) {
            const queryParams = {};
            if (this.valueForSearch) {
                queryParams['search'] = this.valueForSearch;
            }
            if (this.search_filters.length > 0) {
                queryParams['filters'] = this.search_filters.toString();
            }
            if (this.journalid == 'All') {
                this.router.navigate(['/articles/page/1'], { queryParams });
            }
            else {
                this.router.navigate(['/journal/' + this.journalid + '/articles/page/1'], { queryParams });
            }
        }
    }

    checkBoxChange(event: string[]) {
        this.search_filters = event;
    }

    journalEmit(journal: string) {
        this.journalid = journal;
    }
    
    // @HostListener('document:keydown.enter', ['$event']) onKeydownHandler() { //event: KeyboardEvent
    //     this.showSearchedArticle(true);
    // }
    @HostListener('document:keydown.enter', ['$event'])
    onKeydownHandler() {
      if (isPlatformBrowser(this.platformId)) {
        // Code to execute when running in a browser platform
        this.showSearchedArticle(true);
      }
    }
    ngOnDestroy() {
        this.subscriptions.forEach(x => {
            if (!x.closed) {
                x.unsubscribe();
            }
        });
    }
    addColor(event: MouseEvent) {
        const element = event.target as HTMLElement;
        if (element && element.id === 'article-image') {
            element.setAttribute('src', '../../assets/images/banners/banner-single-sample-color.jpg');
        }
    }

    removeColor(event: MouseEvent) {
        const element = event.target as HTMLElement;
        if (element && element.id === 'article-image') {
            element.setAttribute('src', '../../assets/images/banners/banner-single-sample-bw.jpg');
        }
    }
    ensureHttps(url: string): string {
        if (!url.startsWith('http://') && !url.startsWith('https://')) {
            return 'https://' + url;
        }
        return url;
    }
}
